import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { TicketMessage } from "./TicketMessages";
import { User } from "./User";
import TipTapEditor from "../../../components/sub/TipTapEditor";
import { removeHtmlTagsFromString } from "../../../assets/js/mcn-helpers";
import Model from "./Model";
export class Ticket extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "TicketId", {
      fieldName: 'ticket_id',
      fieldTitle: 'Ticket id',
      content: null
    });
    _defineProperty(this, "id", {
      fieldName: 'ticket_id',
      fieldTitle: 'Ticket id',
      content: null
    });
    _defineProperty(this, "Id", {
      fieldName: 'ticket_id',
      fieldTitle: 'Ticket id',
      content: null
    });
    _defineProperty(this, "TicketUser", {
      fieldName: 'ticket_user',
      fieldTitle: 'Ticket user',
      model: User,
      content: null
    });
    _defineProperty(this, "TicketType", {
      fieldName: 'ticket_type',
      fieldTitle: 'Ticket type',
      content: null
    });
    _defineProperty(this, "TicketStatus", {
      fieldName: 'ticket_status',
      fieldTitle: 'Ticket status',
      content: null
    });
    _defineProperty(this, "TicketTicketMessages", {
      fieldName: 'ticket_ticket_messages',
      fieldTitle: 'Ticket ticket message',
      model: TicketMessage,
      content: []
    });
    _defineProperty(this, "TicketForm", {
      TicketMessage: {
        fieldName: 'ticket_message_content',
        fieldTitle: 'support_page.ticket.message_form.fields.message.title',
        component: TipTapEditor,
        max: 5000,
        config: {
          elements: ['bold', 'align', 'list-bulleted', 'list-numbered', 'italic', 'underline', 'strike', 'direction', 'color', 'resizable_image', 'history']
        },
        multimediaType: 'image',
        placeholder: 'support_page.ticket.message_form.fields.message.placeholder',
        content: null,
        messages: []
      },
      TicketSendBtn: {
        content: false
      },
      TicketCloseBtn: {
        content: false
      }
    });
  }
  getId() {
    return this.Id.content;
  }
  getType() {
    return this.TicketType.content;
  }
  getTicketUser() {
    return this.TicketUser.content;
  }
  getTicketMessages() {
    return this.TicketTicketMessages.content;
  }
  getTicketUserName() {
    let user = this.getTicketUser();
    return user instanceof User ? user.getUserName() : null;
  }
  getTicketStatus() {
    return this.TicketStatus.content;
  }
  getMessages() {
    var _this$TicketTicketMes;
    return (_this$TicketTicketMes = this.TicketTicketMessages) === null || _this$TicketTicketMes === void 0 ? void 0 : _this$TicketTicketMes.content;
  }
  getLastMessage() {
    let messages = this.getMessages();
    return (messages === null || messages === void 0 ? void 0 : messages.length) > 0 ? messages[messages.length - 1] : null;
  }
  getOnlyTextLastMessage() {
    var _removeHtmlTagsFromSt, _lastMessage$getConte;
    let lastMessage = this.getLastMessage();
    return (_removeHtmlTagsFromSt = removeHtmlTagsFromString(lastMessage instanceof TicketMessage ? (_lastMessage$getConte = lastMessage.getContent()) !== null && _lastMessage$getConte !== void 0 ? _lastMessage$getConte : '' : '', ['img'])) !== null && _removeHtmlTagsFromSt !== void 0 ? _removeHtmlTagsFromSt : '';
  }
  getOnlyTextLastMessageSample() {
    return this.getOnlyTextLastMessage();
  }
}
_defineProperty(Ticket, "CREATED_STATUS", 'created');
_defineProperty(Ticket, "UPDATED_STATUS", 'updated');
_defineProperty(Ticket, "CLOSED_STATUS", 'closed');
_defineProperty(Ticket, "TECHNICAL_PROBLEM_TYPE", 'Technical-problem');
_defineProperty(Ticket, "HOW_TO_TYPE", 'How-to');
_defineProperty(Ticket, "FEATURE_REQUEST_TYPE", 'Feature-request');
_defineProperty(Ticket, "PAYMENT_TYPE", 'Payment');
export default Ticket;